export const table_GroupBorders = "$gUGkc";
export const table_GroupAccessibility = "YLVvcb";
export const report_GroupButton = "GP6Bfd";
export const teamsChat_Group = "kM5KGe";
export const names_Group = "wlpCwd";
export const table_GroupInsert = "lkvIQ";
export const table_GroupStructure = "zswo2d";
export const pictureFormatting_Group = "z$xA5b";
export const pictureText_Group = "BOab_c";
export const pictureSize_Group = "tIMyIe";
export const pictureMisc_Group = "uHV2kd";
export default {table_GroupBorders,table_GroupAccessibility,report_GroupButton,teamsChat_Group,names_Group,table_GroupInsert,table_GroupStructure,pictureFormatting_Group,pictureText_Group,pictureSize_Group,pictureMisc_Group};